import { useAuth } from 'providers/auth.provider';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const WithAuth = () => {
    const { signedIn } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (signedIn) {
            navigate(`${window.location.pathname}${window.location.search}`);
        } else {
            if (window.location.pathname === "/") {
                navigate("/login");
            }
        }
    }, [signedIn]);

    return (
        <Outlet />
    )
}

export default WithAuth